import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { User } from '@shared/models';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastService } from '@shared/services';
import { TranslateService } from '@ngx-translate/core';
import { showSpinner } from '@shared/utils';
import { AmplitudeEventService } from '@core/services';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  userData = new BehaviorSubject<User | null>(null);

  constructor(
    private http: HttpClient,
    private router: Router,
    private toastService: ToastService,
    private translateService: TranslateService,
    private amplitudeEventService: AmplitudeEventService,
  ) {}

  setUser(user: User): void {
    this.updateAmplitudeBusinessAccountProperty(user.business);
    this.userData.next(user);
  }

  getUserResponse(): Observable<User> {
    return this.http.get<User>('/api/backoffice/v2/customer/self/').pipe(
      catchError(() => {
        this.router.navigateByUrl('/dashboard');
        this.toastService.add({ type: 'error', message: this.translateService.instant('Common.Errors.PageCouldNotBeLoaded') });
        return of();
      }),
    );
  }

  updateUser(user: User): Observable<null> {
    this.updateAmplitudeBusinessAccountProperty(user.business);
    return this.http.put<null>('/api/backoffice/v2/customer/update/', user).pipe(showSpinner());
  }

  updateAmplitudeBusinessAccountProperty(isBusinessAccount: boolean) {
    this.amplitudeEventService.updateUserProperties({
      properties: {
        isBusinessAccount,
      },
    });
  }
}
